import{MediaType as t}from"../../interfaces/DiagnosticReport.js";function r(r){const{media:e}=r[0];return e.type===t.Image?e.url:e.thumbnailUrl??""}export{r as getFirstObservationImage};
